export enum MaritalStatusEnum {
  Single = "SINGLE",
  Married = "MARRIED",
  CommonLaw = "COMMON_LAW",
  Separated = "SEPARATED",
  Divorced = "DIVORCED",
  Widowed = "WIDOWED",
  Other = "OTHER",
}

export const MaritalStatusMapping: Record<string, MaritalStatusEnum> = {
  Single: MaritalStatusEnum.Single,
  Married: MaritalStatusEnum.Married,
  "Common Law": MaritalStatusEnum.CommonLaw,
  Separated: MaritalStatusEnum.Separated,
  Divorced: MaritalStatusEnum.Divorced,
  Widowed: MaritalStatusEnum.Widowed,
  Other: MaritalStatusEnum.Other,
};

export enum OperatingTypeEnum {
  Corporation = "CORPORATION",
  SoleProprietorship = "SOLE_PROPRIETORSHIP",
  Partnership = "PARTNERSHIP",
  LimitedPartnership = "LIMITED_PARTNERSHIP",
  LimitedLiabilityPartnership = "LIMITED_LIABILITY_PARTNERSHIP",
  Cooperative = "COOPERATIVE",
  NonProfitOrganization = "NON_PROFIT_ORGANIZATION",
}

export const OperatingTypeMapping: Record<string, OperatingTypeEnum> = {
  Corporation: OperatingTypeEnum.Corporation,
  "Sole Proprietorship": OperatingTypeEnum.SoleProprietorship,
  Partnership: OperatingTypeEnum.Partnership,
  "Limited Partnership": OperatingTypeEnum.LimitedPartnership,
  "Limited Liability Partnership":
    OperatingTypeEnum.LimitedLiabilityPartnership,
  Cooperative: OperatingTypeEnum.Cooperative,
  "Non Profit Organization": OperatingTypeEnum.NonProfitOrganization,
};

export enum IncomeTypeEnum {
  Alimony = "ALIMONY",
  ChildSupport = "CHILD_SUPPORT",
  InvestmentIncome = "INVESTMENT_INCOME",
  CanadaChildBenefit = "CANADA_CHILD_BENEFIT",
  MaternityLeave = "MATERNITY_LEAVE",
  Pension = "PENSION",
  Disability = "DISABILITY",
  Student = "STUDENT",
  Unemployment = "UNEMPLOYMENT",
}

export const IncomeTypeMapping: Record<string, IncomeTypeEnum> = {
  Alimony: IncomeTypeEnum.Alimony,
  "Child Support": IncomeTypeEnum.ChildSupport,
  "Investment Income": IncomeTypeEnum.InvestmentIncome,
  "Canada Child Benefit": IncomeTypeEnum.CanadaChildBenefit,
  "Maternity Leave": IncomeTypeEnum.MaternityLeave,
  Pension: IncomeTypeEnum.Pension,
  Disability: IncomeTypeEnum.Disability,
  Student: IncomeTypeEnum.Student,
  Unemployment: IncomeTypeEnum.Unemployment,
};

export enum PropertyTypeEnum {
  Detached = "DETACHED",
  SemiDetached = "SEMI_DETACHED",
  Townhouse = "TOWNHOUSE",
  CondoTownhouse = "CONDO_TOWNHOUSE",
  Apartment = "APARTMENT",
  Condo = "CONDO",
}

export const PropertyTypeMapping: Record<string, PropertyTypeEnum> = {
  Detached: PropertyTypeEnum.Detached,
  "Semi Detached": PropertyTypeEnum.SemiDetached,
  Townhouse: PropertyTypeEnum.Townhouse,
  "Condo Townhouse": PropertyTypeEnum.CondoTownhouse,
  Apartment: PropertyTypeEnum.Apartment,
  Condo: PropertyTypeEnum.Condo,
};

export enum CoApplicantIncomeSourceEnum {
  Employment = "EMPLOYMENT",
  SelfEmployment = "SELF_EMPLOYMENT",
  Investment = "INVESTMENT",
  Rental = "RENTAL",
  Pension = "PENSION",
  GovernmentBenefits = "GOVERNMENT_BENEFITS",
  CommissionBased = "COMMISSION_BASED",
  ContractWork = "CONTRACT_WORK",
  DisabilityBenefits = "DISABILITY_BENEFITS",
  Other = "OTHER",
}

export const CoApplicantIncomeSourceMapping: Record<
  string,
  CoApplicantIncomeSourceEnum
> = {
  Employment: CoApplicantIncomeSourceEnum.Employment,
  "Self Employment": CoApplicantIncomeSourceEnum.SelfEmployment,
  Investment: CoApplicantIncomeSourceEnum.Investment,
  Rental: CoApplicantIncomeSourceEnum.Rental,
  Pension: CoApplicantIncomeSourceEnum.Pension,
  "Government Benefits": CoApplicantIncomeSourceEnum.GovernmentBenefits,
  "Commission Based": CoApplicantIncomeSourceEnum.CommissionBased,
  "Contract Work": CoApplicantIncomeSourceEnum.ContractWork,
  "Disability Benefits": CoApplicantIncomeSourceEnum.DisabilityBenefits,
  Other: CoApplicantIncomeSourceEnum.Other,
};

export enum RelationshipEnum {
  Child = "CHILD",
  Spouse = "SPOUSE",
  Parent = "PARENT",
  Sibling = "SIBLING",
  OtherFamilyMember = "OTHER_FAMILY_MEMBER",
  BusinessPartner = "BUSINESS_PARTNER",
  NonRelated = "NON_RELATED",
}

export const RelationshipMapping: Record<string, RelationshipEnum> = {
  Child: RelationshipEnum.Child,
  Spouse: RelationshipEnum.Spouse,
  Parent: RelationshipEnum.Parent,
  Sibling: RelationshipEnum.Sibling,
  "Other Family Member": RelationshipEnum.OtherFamilyMember,
  "Business Partner": RelationshipEnum.BusinessPartner,
  "Non Related": RelationshipEnum.NonRelated,
};

export enum DownPaymentSourceEnum {
  CashSavings = "CASH_SAVINGS",
  RRSP = "RRSP",
  FHSA = "FHSA",
  Gift = "GIFT",
  SaleOfProperty = "SALE_OF_PROPERTY",
  Other = "OTHER",
}

export const DownPaymentSourceMapping: Record<string, DownPaymentSourceEnum> = {
  "Bank Account": DownPaymentSourceEnum.CashSavings,
  RRSP: DownPaymentSourceEnum.RRSP,
  Gift: DownPaymentSourceEnum.Gift,
  FHSA: DownPaymentSourceEnum.FHSA,
  "Sale of my Existing Property": DownPaymentSourceEnum.SaleOfProperty,
  "Other Income": DownPaymentSourceEnum.Other,
};

export enum DocumentTypeEnum {
  PhotoId = "PHOTO_ID",
  T4 = "T4",
  PayStub = "PAY_STUB",
}

export enum CanadianProvinceCodeEnum {
  Alberta = "AB",
  BritishColumbia = "BC",
  Manitoba = "MB",
  NewBrunswick = "NB",
  NewfoundlandAndLabrador = "NL",
  NovaScotia = "NS",
  Ontario = "ON",
  PrinceEdwardIsland = "PE",
  Quebec = "QC",
  Saskatchewan = "SK",
  NorthwestTerritories = "NT",
  Nunavut = "NU",
  Yukon = "YT",
}

export interface AddressInterface {
  address1: string;
  address2?: string;
  city: string;
  state: CanadianProvinceCodeEnum | string;
  postalCode: string;
  country: string;
}

export interface CurrencyInterface {
  amount: number;
  currency: string;
}

export enum MortgageStatusEnum {
  Incomplete = "INCOMPLETE",
  PendingDocuments = "PENDING_DOCUMENTS",
  PendingContact = "PENDING_CONTACT",
  PendingApproval = "PENDING_APPROVAL",
  Approved = "APPROVED",
}

export interface FilesInterface {
  filename: string;
  size: number;
  id: string;
  type: DocumentTypeEnum;
}

export interface MortgagePayloadInterface {
  firstName?: string;
  middleName?: string;
  lastName?: string;
  phoneNumber?: string;
  address?: AddressInterface;
  emailAddress?: string;
  dateOfBirth?: Date;
  maritalStatus?: MaritalStatusEnum;
  referralCode?: string;
  // totalMonthlyDebt?: CurrencyInterface;
  isFirstTimeHomeBuyer?: boolean;
  incomeSource?: {
    fullTime?: {
      employerName: string;
      jobTitle: string;
      startDate: Date;
      annualBasePay: CurrencyInterface;
      annualBonuses: CurrencyInterface;
      annualOvertime: CurrencyInterface;
      annualCommission: CurrencyInterface;
    }[];
    partTime?: {
      employerName: string;
      jobTitle: string;
      startDate: Date;
      annualBasePay: CurrencyInterface;
      annualBonuses: CurrencyInterface;
      annualOvertime: CurrencyInterface;
      annualCommission: CurrencyInterface;
    }[];
    selfEmployment?: {
      businessName: string;
      dateEstablished: Date;
      startDate: Date;
      annualBasePay: CurrencyInterface;
      operatingType: OperatingTypeEnum;
      jobTitle: string;
      annualIncome: CurrencyInterface;
    }[];
    rentalIncome?: {
      propertyType: PropertyTypeEnum;
      annualAmount: CurrencyInterface;
      propertyAddress: AddressInterface;
      propertyValue: CurrencyInterface;
      monthlyRent: CurrencyInterface;
      rentalIncomeSince: Date;
    }[];
    otherIncome?: {
      incomeType: IncomeTypeEnum;
      annualAmount: CurrencyInterface;
      startDate: Date;
    }[];
  };
  coApplicants?: {
    firstName: string;
    middleName?: string;
    lastName: string;
    address: AddressInterface;
    phoneNumber: string;
    emailAddress: string;
    dateOfBirth: Date;
    maritalStatus: MaritalStatusEnum;
    relationship: RelationshipEnum;
    incomeSource: CoApplicantIncomeSourceEnum;
    isFirstTimeHomeBuyer: boolean;
    // totalMonthlyDebt: CurrencyInterface;
    annualBasePay: CurrencyInterface;
  }[];
  downPaymentSources?: {
    type: DownPaymentSourceEnum;
    amount: CurrencyInterface;
  }[];
  files?: FilesInterface[];

  creditConsents?: {
    firstName: string;
    middleName?: string;
    lastName: string;
    dateOfBirth: Date;
    phoneNumber: string;
    address: AddressInterface;
  }[];

  status?: MortgageStatusEnum;
  calculations?: {
    creditScore: number | null;
    maximumPurchasePrice: CurrencyInterface | null;
    downPaymentAssistance: CurrencyInterface | null;
    minDownPaymentNeeded: CurrencyInterface | null;
    newDownPaymentNeeded: CurrencyInterface | null;
  };
}
